export const normalizeDescricao = (descricao: string) => {
  return descricao
    ?.toLowerCase()
    .replace(/‡/g, "ç")
    .replace(/æ/g, "ã")
    .replace(/‰/g, "õ")
    .replace(/ˆ/g, "ê");
};
